import React from 'react';
import PropTypes from 'prop-types';

export default function Button({ className, text, urlLink }) {
    const onClickFcn = () => {
        window.open(urlLink, '_blank');
    }
    
    return (
        <button className={ className } onClick={ urlLink ? onClickFcn : undefined }>
            { text }
        </button>
    )
}

Button.propTypes = {
    className: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
    urlLink: PropTypes.string
};
